import { FieldEditorProps } from "../../types";

interface TimeEditorProps extends FieldEditorProps {}

const TimeEditor: React.FC<TimeEditorProps> = (props) => {
  return <></>;
};

export default TimeEditor;
